var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHAT_ACTIVITY_BREAKDOWN_KEYS, emptyChatActivityBreakdownCounts } from '@workalizer/shared';
import { getInterval, getPercentageDiff, groupByPeriod, randomInt } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var generateMockCounts = function () { return ({
    messagesSent: randomInt(30, 90),
    reactionsSent: randomInt(5, 25),
    messagesReceived: randomInt(35, 100),
    reactionsReceived: randomInt(5, 20)
}); };
export var chatActivityBreakdown = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var periodsData = periods.map(function (period) {
        var counts = generateMockCounts();
        return __assign({ period: period.date }, counts);
    });
    var currentTotals = periodsData.reduce(function (acc, period) {
        for (var _i = 0, CHAT_ACTIVITY_BREAKDOWN_KEYS_1 = CHAT_ACTIVITY_BREAKDOWN_KEYS; _i < CHAT_ACTIVITY_BREAKDOWN_KEYS_1.length; _i++) {
            var key = CHAT_ACTIVITY_BREAKDOWN_KEYS_1[_i];
            acc[key] += period[key];
        }
        return acc;
    }, emptyChatActivityBreakdownCounts());
    var previousTotals = CHAT_ACTIVITY_BREAKDOWN_KEYS.reduce(function (acc, key) {
        acc[key] = randomInt(Math.max(1, Math.floor(currentTotals[key] * 0.7)), Math.max(1, Math.floor(currentTotals[key] * 1.1)));
        return acc;
    }, emptyChatActivityBreakdownCounts());
    var teamTotals = input.userId
        ? CHAT_ACTIVITY_BREAKDOWN_KEYS.reduce(function (acc, key) {
            acc[key] = randomInt(Math.max(1, Math.floor(currentTotals[key] * 0.8)), Math.max(1, Math.floor(currentTotals[key] * 1.2)));
            return acc;
        }, emptyChatActivityBreakdownCounts())
        : undefined;
    return {
        periods: periodsData,
        totals: Object.fromEntries(CHAT_ACTIVITY_BREAKDOWN_KEYS.map(function (key) { return [
            key,
            __assign({ current: currentTotals[key], previous: getPercentageDiff(previousTotals[key], currentTotals[key]) }, (teamTotals && {
                teamAverage: getPercentageDiff(teamTotals[key], currentTotals[key])
            }))
        ]; }))
    };
};
